<template>
  <div class="event-group">
    <div :class="['group-header', { active: isActive }]">
      <p>{{ getGroupDate }}</p>
      <p>{{ `${events.length} events` }}</p>
    </div>
    <div
      v-for="(event, index) in events"
      :key="index"
      :class="['event-item', { active: isActive && selectedEvent === index }]"
      @click="$emit('selected', index)"
    >
      <label>{{ getTime(event.timestamp) }}</label>
      <icon size="18" class="event-icon">fiber_manual_record</icon>
      <div class="flex-col flex-expand">
        <p>{{ event.data[event.data.length - 1].value || "null" }}</p>
        <div class="event-meta">
          <div
            v-for="(data, index) in event.data.slice(0, event.data.length - 1)"
            :key="index"
          >
            {{ data.column.split("__")[1] || data.column }}:
            {{ data.value || "null" }}
          </div>
        </div>
      </div>
      <icon class="show-on-map">keyboard_arrow_right</icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    events: Array,
    date: Date,
    selectedEvent: Number,
    isActive: Boolean,
  },
  data() {
    return {
      months: [
        "January",
        "february",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  computed: {
    getGroupDate() {
      return `${this.date.getDate()} ${
        this.months[this.date.getMonth()]
      } ${this.date.getFullYear()}`;
    },
  },
  methods: {
    getTime(date) {
      return `${date.getHours()}:${date.getMinutes() ||
        "00"}:${date.getSeconds() || "00"}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.event-group {
  display: flex;
  flex-direction: column;

  .group-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background: var(--color-secondary-light);

    p {
      margin: 0;
      padding: 0;
    }

    &.active {
      color: var(--color-primary);
    }
  }

  .event-item {
    display: flex;
    flex-direction: row;
    padding: 10px 15px;
    align-items: center;
    border-bottom: 1px solid var(--border-color);

    p {
      margin: 0;
      padding: 0;
      text-overflow: ellipsis;
      font-weight: bold;
    }

    label {
      opacity: 0.8;
      font-size: 0.8;
      pointer-events: none;
    }

    .show-on-map {
      display: none;
    }

    .event-icon {
      margin: 16px;
    }

    .event-meta {
      margin-top: 12px;
    }

    &:hover,
    &.active {
      background: var(--border-color);
      color: var(--color-primary);
      cursor: pointer;

      .show-on-map {
        display: flex;
      }
    }
  }
}
</style>
